import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { createInvoice } from 'modules/accommodations/features/reservations/api';

export const useMutationCreateInvoice = () => {
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const queryClient = useQueryClient();

  return useMutation(createInvoice, {
    onSuccess: () => {
      successToast(t('Guest invoice successfully created'));
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_ACCOMMODATION_INVOICES);
    },
    onError: (error: AxiosError) => {
      if (error?.message.includes('403')) {
        errorToast(t('Access denied'));

        return;
      }

      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
